import React, { ReactElement } from "react";

import { TextManager } from "Components/TextContext";
import { Table } from "Components/TextContext/commonComponentEnums";
import { Plurals } from "Components/TextContext/textInterfaces";
import { isDefined } from "Utils/functions";
import { DiscountText } from "./discountMessageStyled";

interface Props {
  readonly insuranceCount?: number;
}

export const InsuranceCount = ({
  insuranceCount,
}: Props): ReactElement | null => {
  const { getText } = TextManager;

  if (!isDefined(insuranceCount)) {
    return null;
  }

  const pluralForm: Plurals = insuranceCount === 1 ? "one" : "many";

  return (
    <DiscountText>
      {getText(Table.INSURANCE_COUNT_HEADING, {
        variables: {
          common_insurance_count: insuranceCount,
        },
        plurals: pluralForm,
      })}
    </DiscountText>
  );
};
